<template>
  <v-col cols="12">
    <v-card>
      <v-card-title class="text-h5"> Top 50 Insider Open Market Buys </v-card-title>

      <v-card-text>
        <!-- Options -->
        <v-row density="compact">
          <v-col cols="12" md="4">
            <h3 style="text-align: center; font-weight: bold">MTD</h3>
            <v-data-table
              v-model:options="paginationMtd"
              v-model:sort-by="paginationMtd.sortBy"
              :headers="tableHeaders"
              :items="tableItemsMtd"
              :items-per-page-options="[10, 25, 50, 100]"
              :loading="loading"
              :no-data-text="loading ? 'Loading...' : 'No results found.'"
              must-sort
            >
              <template #item.name="{ item }">
                <a :href="'/stock/' + item.stock_permalink" target="_blank">{{ item.name }}</a>
              </template>
              <template #item.transaction_shares="{ item }">
                {{ human_number(item.transaction_shares) }}
              </template>
              <template #item.transaction_amount="{ item }">
                ${{ human_number(item.transaction_amount) }}
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" md="4">
            <h3 style="text-align: center; font-weight: bold">QTD</h3>
            <v-data-table
              v-model:sort-by="paginationQtd.sortBy"
              v-model:options="paginationQtd"
              :headers="tableHeaders"
              :items="tableItemsQtd"
              :items-per-page-options="[10, 25, 50, 100]"
              :loading="loading"
              :no-data-text="loading ? 'Loading...' : 'No results found.'"
              must-sort
            >
              <template #item.name="{ item }">
                <a :href="'/stock/' + item.stock_permalink" target="_blank">{{ item.name }}</a>
              </template>
              <template #item.transaction_shares="{ item }">
                {{ human_number(item.transaction_shares) }}
              </template>
              <template #item.transaction_amount="{ item }">
                ${{ human_number(item.transaction_amount) }}
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" md="4">
            <h3 style="text-align: center; font-weight: bold">YTD</h3>
            <v-data-table
              v-model:sort-by="paginationYtd.sortBy"
              v-model:options="paginationYtd"
              :headers="tableHeaders"
              :items="tableItemsYtd"
              :items-per-page-options="[10, 25, 50, 100]"
              :loading="loading"
              :no-data-text="loading ? 'Loading...' : 'No results found.'"
              must-sort
            >
              <template #item.name="{ item }">
                <a :href="'/stock/' + item.stock_permalink" target="_blank">{{ item.name }}</a>
              </template>
              <template #item.transaction_shares="{ item }">
                {{ human_number(item.transaction_shares) }}
              </template>
              <template #item.transaction_amount="{ item }">
                ${{ human_number(item.transaction_amount) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- Table -->
      </v-card-text>
    </v-card>

    <transaction-details-dialog ref="transactionDetailsDialog" />
  </v-col>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

// Components
import TransactionDetailsDialog from '@/components/page/insider-dashboard/_TransactionDetailsDialog'

export default {
  components: {
    TransactionDetailsDialog
  },
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      tableHeaders: [
        { title: 'Name', key: 'name', width: 1, sortable: false },
        { title: 'Ticker', key: 'symbol' },
        { title: 'Trans. Count', key: 'count' },
        { title: 'Total Shares', key: 'transaction_shares' },
        { title: 'Total Amount', key: 'transaction_amount' }
      ],
      tableItemsMtd: [],
      tableItemsQtd: [],
      tableItemsYtd: [],
      paginationMtd: {
        sortBy: [{ key: 'transaction_amount', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      paginationQtd: {
        sortBy: [{ key: 'transaction_amount', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      paginationYtd: {
        sortBy: [{ key: 'transaction_amount', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      criteriaMtd: {
        transaction_type: 2,
        date_range: 'mtd',
        owner_types: 5,
        minimum_unique_owners: null,
        minimum_transaction_amount: null,
        show_infrequent: true
      },
      criteriaYtd: {
        transaction_type: 2,
        date_range: 'ytd',
        owner_types: 5,
        minimum_unique_owners: null,
        minimum_transaction_amount: null,
        show_infrequent: true
      },
      criteriaQtd: {
        transaction_type: 2,
        date_range: 'qtd',
        owner_types: 5,
        minimum_unique_owners: null,
        minimum_transaction_amount: null,
        show_infrequent: true
      }
    }
  },

  watch: {},

  created() {
    this.updateData(this.criteriaQtd, 'tableItemsQtd')
    this.updateData(this.criteriaMtd, 'tableItemsMtd')
    this.updateData(this.criteriaYtd, 'tableItemsYtd')
  },

  methods: {
    updateData: function (criteria, tableItems) {
      this.loading = true

      api
        .post('form4_top_buyers', criteria)
        .then(response => {
          this[tableItems] = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }
  }
}
</script>
